import { ProductCustomPriceTypeEnum } from '@c2b/muven-commons';
import { ChannelModel } from '../../channel/models/ChannelModel';

export class ProductStoreChannelModel {
    id?: string;
    idChannel?: string;
    idExternalChannel?: string;
    channel?:ChannelModel = undefined;
    pricePercentage: number = 0;
    priceDecimalsPreference?: number;
    availableStockPercentage: number = 100;
    sellPrice:number = 0;
    listPrice:number = 0;
    calculatedListPrice:number = 0;
    calculatedSellPrice:number = 0;
    calculatedStockQty:number = 0;
    priceUponRequest: boolean|null = null;
    isActive: boolean = false;
    validInChannel: boolean = true;
    customPriceType: ProductCustomPriceTypeEnum = ProductCustomPriceTypeEnum.Percentage;
    hasMinimalStock: boolean = false;
    minimalStock: number = 0;
    storeName?: string = undefined;

    constructor(p?: Partial<ProductStoreChannelModel>) {
        Object.assign(this, p)

        this._parseChannel()
    }

    private _parseChannel():void {
        this.channel = new ChannelModel(this.channel)
    }
}
